import { combineReducers } from 'redux'
import locationReducer from './location'
import navBarReducer from './navbar'
import modalReducer from './modal'
import loadingReducer from './loader'
import stringsReducer from './strings'
import newParticipantReducer from './newParticipant'
import { errorReducer } from '../layouts/ErrorBox'

export const makeRootReducer = asyncReducers => {
  const combinedReducer = combineReducers({
    location: locationReducer,
    navBar: navBarReducer.navProps,
    errorBox: errorReducer,
    modal: modalReducer,
    loading: loadingReducer,
    participant: newParticipantReducer,
    strings: stringsReducer,
    ...asyncReducers,
  })

  const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGGED_OUT') {
      // return initial state for all reducers
      state = undefined
    }

    return combinedReducer(state, action)
  }

  return rootReducer
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export const injectReducers = (store, reducers) => {
  Object.keys(reducers).forEach(key => {
    injectReducer(store, { key, reducer: reducers[key] })
  })
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js